/**
 * The DevToolState type is defined as a union of specific string literals and a generic string type.
 * This allows for code editor suggestions for the defined values while still permitting any string value.
 * The intersection with an empty object type (string & {}) ensures that the type is not reduced to just 'string'.
 * @see https://github.com/microsoft/TypeScript/issues/29729
 */
export type DevToolState = 'loading' | 'error' | 'empty' | 'zero' | 'data' | 'none' | (string & {});

export type KnownStates = {
  [K in Uppercase<DevToolState>]: DevToolState;
};

export type KnownDevToolStateFlags = {
  [K in DevToolState as `isDevTool${Capitalize<K>}StateEnabled`]: boolean;
};

export type DevToolStateFlags<S extends string> = KnownDevToolStateFlags & {
  [K in `isDevTool${Capitalize<S>}StateEnabled`]: boolean;
};

export enum DevPanelFilterKeys {
  SENDS = 'sends',
  GOALS = 'goals',
  ALERTS = 'alerts',
  USER_ACTIVITY = 'user-activity',
}

export type DevPanelFilter = {
  id: DevPanelFilterKeys;
  value: string;
  label: string;
};
